import { Isvg } from './svg.interface';

const WarningSVG = ({ width = 16, height = 17, color = '#212B36' }: Isvg) => (
  <svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0402 11.3666L9.9269 2.88663C9.50671 2.22929 8.78039 1.83154 8.00023 1.83154C7.22007 1.83154 6.49375 2.22929 6.07356 2.88663L0.96023 11.3666C0.592594 11.9795 0.579887 12.7419 0.926897 13.3666C1.32821 14.0701 2.07705 14.5031 2.8869 14.5H13.1136C13.9179 14.5085 14.6655 14.0865 15.0736 13.3933C15.431 12.7617 15.4182 11.9861 15.0402 11.3666ZM8.00023 11.8333C7.63204 11.8333 7.33356 11.5348 7.33356 11.1666C7.33356 10.7984 7.63204 10.5 8.00023 10.5C8.36842 10.5 8.6669 10.7984 8.6669 11.1666C8.6669 11.5348 8.36842 11.8333 8.00023 11.8333ZM8.00023 9.83329C8.36842 9.83329 8.6669 9.53481 8.6669 9.16663V6.49996C8.6669 6.13177 8.36842 5.83329 8.00023 5.83329C7.63204 5.83329 7.33356 6.13177 7.33356 6.49996V9.16663C7.33356 9.53481 7.63204 9.83329 8.00023 9.83329Z"
      fill="#FFC107"
    />
  </svg>
);

export default WarningSVG;
